<template>
  <section :class="['activity','theme_'+$store.state.common.theme]">
    <section v-if="$store.state.common.theme!=3" class="title_box">
      <h2 class="title_left">{{items.title}}</h2>
      <router-link tag="span" class="title_right" to="/activity">更多</router-link>
    </section>
    <section v-if="$store.state.common.theme==3" class="title_box_theme3">
      <h2 class="title_left">{{'活动公告'}}</h2>
      <router-link tag="span" class="title_right" to="/activity">更多</router-link>
    </section>
    <template v-if="$store.state.common.theme!=3">
      <ul class="activity_list" v-if="items.listStyle == 1">
        <div tag="li" @click="toActivityDetail(item.actId)" class="list_item" v-for="(item,index) in newList" :key="index">
          <div class="imgDiv">
            <img :src="item.actImg" alt>
            <span :class="['activity_ing_status',item.statusCN == '已结束'?'status_end':'',item.statusCN=='未开始'?'status_unstart':'']">{{item.statusCN}}</span>
          </div>
          <p>{{item.actTitle}}</p>
          <span class="time">{{item.actBegTime | time}} 至 {{item.actEndTime | time}}</span>
        </div>
      </ul>
      <ul class="activity_list_two" v-if="items.listStyle == 0">
        <div
          tag="li"
          @click="toActivityDetail(item.actId)"
          class="list_item"
          v-for="(item,index) in newList"
          :key="index"
        >
          <div class="top_div">
            <img :src="item.actImg" />
            <span
              :class="['activity_ing_status',item.statusCN == '已结束'?'status_end':'',item.statusCN=='未开始'?'status_unstart':'']"
            >{{item.statusCN}}</span>
            <div class="actLabel">
              <span v-for="cur in item.actLabel" :key="cur"># {{cur}}</span>
            </div>
          </div>
          <div class="bottom_div">
            <div class="bottom_left">
              <h2>{{item.actTitle}}</h2>
              <p class="time">{{item.actBegTime | time}} - {{item.actEndTime | time}}</p>
            </div>
            <div class="bottom_right">
            </div>
          </div>
        </div>
      </ul>
    </template>
    <template v-if="$store.state.common.theme==3">
      <ul class="activity_list_t3" v-if="items.listStyle == 1">
        <div tag="li" @click="toActivityDetail(item.actId)" class="list_item" v-for="(item,index) in newList" :key="index">
          <div class="imgDiv">
            <img :src="item.actImg" alt>
            <span :class="['activity_ing_status',item.statusCN == '已结束'?'status_end':'',item.statusCN=='未开始'?'status_unstart':'']">{{item.statusCN}}</span>
          </div>
          <p>{{item.actTitle}}</p>
          <span class="time">{{item.actBegTime | time}} 至 {{item.actEndTime | time}}</span>
        </div>
      </ul>
      <ul class="activity_list_two_t3" v-if="items.listStyle ==0">
        <div
          tag="li"
          @click="toActivityDetail(item.actId)"
          class="list_item"
          v-for="(item,index) in newList"
          :key="index"
        >
          <div class="top_div">
            <img :src="item.actImg" />
            <span
              :class="['activity_ing_status',item.statusCN == '已结束'?'status_end':'',item.statusCN=='未开始'?'status_unstart':'']"
            >{{item.statusCN}}</span>
            <!-- <div class="actLabel">
              <span v-for="cur in item.actLabel" :key="cur"># {{cur}}</span>
            </div> -->
          </div>
          <div class="bottom_div">
            <div class="bottom_left">
              <h2>{{item.actTitle}}</h2>
              <p class="time">{{item.actBegTime | time}} - {{item.actEndTime | time}}</p>
            </div>
            <div class="bottom_right">
              <span class="price">查看详情</span>
            </div>
          </div>
        </div>
      </ul>
    </template>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import util from "../../../utils/util";
export default {
  name: "indexActivity",
  components: {},
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    items: {
      type: Object,
      default() {
        return {
          listStyle:0
        }

      }
    }
  },
  data() {
    return {};
  },
  computed: {
    newList () {
      if (this.items.listStyle === 1) {
        return this.list
      } else {
        return this.list.slice(0, 2)
      }
    },
     ...mapState({
      common: state => state.common
    })
  },
  filters: {
    time(val) {
      return util.formatTime(new Date(val), 6);
    }
  },
  methods: {
    toActivityDetail(id){
      var url = `/activityDetails/${id}`;
      if(this.common.marketInfo.id){
         url =url +"?marketId="+this.common.marketInfo.id
         if(this.common.cityId){
            url =url +"&cityId="+this.common.cityId
         }
      }
      this.$router.push(url);
    }
  }
};
</script>
<!--  background-color: #fff; -->
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.wrapper {
  width: 100%;
}

.activity {
  padding: .14rem 0.2rem 0;
 
  .title_box {
    .flex();
    justify-content: space-between;
    align-items: center;
    height: 1rem;
    .title_left {
      .flex();
      flex-direction: row;
      font-size: 0.36rem;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      padding-left: 0.56rem;
      background: url("../../../assets/images/icon_hot.png") left center
        no-repeat;
      background-size: 0.32rem 0.32rem;
    }
    .title_right {
      font-size: 0.26rem;
      color: #666;
    }
  }
  .title_box_theme3 {
    .flex();
    justify-content: space-between;
   
    align-items: center;
    height: .44rem;
    margin-bottom: 0.26rem;
    .title_left {
      .flex();
      flex-direction: row;
      font-size:40px;
      line-height: 44px;
      font-weight: bold;
      color: #000000;
      padding-right: 0.56rem;
      background: url("../../../assets/images/icon_hot_3.png") right center
        no-repeat;
      background-size: 44px 44px;
    }
    .title_right {
      font-size: 0.26rem;
      color: #c9a779;
    }
  }

  
}

.activity_list_two {
  overflow:hidden;
  .list_item {
    .flex();
    flex-direction: column;
    position: relative;
    overflow: hidden;
    margin-bottom: 0.28rem;
    margin-top: 0.14rem;
    .top_div{
      position: relative;
      width: 100%;
      height: 4.72rem;
    }
    img {
      display: block;
      width: 100%;
      height: 4.72rem;
      object-fit: cover;
    }

    .actLabel {
      position: absolute;
      bottom: .2rem;
      left: 0;
      right: 0.2rem;
      height: 0.4rem;
      .flex();
      flex-direction: row;
      z-index: 2;
      justify-content: flex-end;
      span {
        display: block;
        height: 0.4rem;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 0.04rem;
        line-height: 0.4rem;
        padding: 0 0.12rem;
        margin-left: 0.1rem;
        font-size: 0.24rem;
        color: #fff;
      }
    }

    .activity_ing_status {
      display: block;
      width: 1rem;
      height: 0.44rem;
      position: absolute;
      top: 0.26rem;
      background: linear-gradient(
        270deg,
        rgba(125, 0, 255, 1) 0%,
        rgba(0, 55, 255, 1) 100%
      );
      left: 0.2rem;
      text-align: center;
      line-height: 0.44rem;
      font-size: 0.28rem;
      color: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: center;
      border-radius: 0.04rem;
    }
    
    .status_end {
      background: #999;
    }
    .status_unstart {
      background: #ff7e1e;
    }

    .bottom_div {
      display: flex;
      background-color: #ffffff;
      width: 100%;
      border-radius: 0rem 0rem 0.16rem 0.16rem;
      flex-direction: row;
      position: relative;
      .bottom_left {
        width: 100%;
        box-sizing: border-box;
        margin-top: 0.2rem;
        padding-left: 0.2rem;
        h2 {
          font-size: 0.32rem;
          font-weight: bold;
          color: #333;
          line-height: 0.44rem;
          .textOver(100%);
        }
        p {
          font-size: 0.28rem;
          color: #999;
          line-height: 0.4rem;
          padding-left: 0.4rem;
          background: url("../../../assets/images/time.png") left center
            no-repeat;
          background-size: 0.28rem 0.28rem;
          margin-top: 0.08rem;
        }
      }
      .bottom_right {
        position: absolute;
        top: 0.28rem;
        right: 0.28rem;
        white-space: nowrap;
        background: #fff;
        .free {
          height: 0.44rem;
          font-size: 0.28rem;
          color: rgba(51, 51, 51, 1);
          line-height: 0.4rem;
        }
        .price {
          height: 0.44rem;
          font-size: 0.32rem;
          color: rgba(51, 51, 51, 1);
          line-height: 0.44rem;
        }
      }
    }
  }
}
.activity_list_scroll {
  white-space: nowrap;
  width: 100%;
}
.activity_list {
  .flex();
  width: 100%;
  justify-content: space-between;
  .list_item {
    .flex();
    flex-direction: column;
    width: 344px;
    background-color: #FFFFFF;
    overflow: hidden;
    margin-bottom: 20px;

    .imgDiv{
      position: relative;
      img {
        display: block;
        width: 344px;
        height: 228px;
        background:#f0f4f7;
      }
      .activity_ing_status{
        position: absolute;
        left: 0;
        top: 0;
        height:40px;
        background: linear-gradient(
        270deg,
        rgba(125, 0, 255, 1) 0%,
        rgba(0, 55, 255, 1) 100%
      );
        padding:0 10px;
        .fontSize(12px);
        color:rgba(255,255,255,1);
        line-height:40px;
        z-index: 2;
      }

      .status_end{
        background:rgba(153,153,153,1);
      }

      .status_unstart{
        background:rgba(255,173,93,1);
      }

    }
    p {
      .fontSize(14px);
      font-weight: bold;
      color: @color3;
      line-height: 40px;
      margin-left: 10px;
      margin-top: 16px;
      .textOver(310px);
    }

    .time{
      margin-left: 10px;
      .fontSize(12px);
      color: @color9;
      line-height: 34px;
      margin-top:3px;
      .textOver(310px);
      margin-bottom:20px;
    }


  }
}

.activity_list_t3 {
  .flex();
  width: 100%;
  justify-content: space-between;
  .list_item {
    .flex();
    flex-direction: column;
    width: 344px;
    background-color: #FFFFFF;
    overflow: hidden;
    margin-bottom: 20px;

    .imgDiv{
      position: relative;
      img {
        display: block;
        width: 344px;
        height: 228px;
        background:#f0f4f7;
      }
      .activity_ing_status{
        position: absolute;
        left: 0;
        top: 0;
        height:40px;
        background: #EEC543;
        padding:0 10px;
        .fontSize(12px);
        color:rgba(255,255,255,1);
        line-height:40px;
        z-index: 2;
      }

      .status_end{
        background:rgba(153,153,153,1);
      }

      .status_unstart{
        background:rgba(255,173,93,1);
      }

    }
    p {
      .fontSize(14px);
      font-weight: bold;
      color: @color3;
      line-height: 40px;
      margin-left: 10px;
      margin-top: 16px;
      .textOver(310px);
    }

    .time{
      margin-left: 10px;
      .fontSize(12px);
      color: @color9;
      line-height: 34px;
      margin-top:3px;
      .textOver(310px);
      margin-bottom:20px;
    }


  }
}

.activity_list_two_t3 {
  overflow:hidden;
  .list_item {
    .flex();
    flex-direction: column;
    position: relative;
    overflow: hidden;
    margin-bottom: 20px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    .top_div{
      position: relative;
      width: 100%;
      height: 296px;
    }
    img {
      display: block;
      width: 100%;
      height: 296px;
      object-fit: cover;
    }

    .actLabel {
      position: absolute;
      bottom: .2rem;
      left: 0;
      right: 0.2rem;
      height: 0.4rem;
      .flex();
      flex-direction: row;
      z-index: 2;
      justify-content: flex-end;
      span {
        display: block;
        height: 0.4rem;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 0.04rem;
        line-height: 0.4rem;
        padding: 0 0.12rem;
        margin-left: 0.1rem;
        font-size: 0.24rem;
        color: #fff;
      }
    }

    .activity_ing_status {
      display: block;
      width: 1rem;
      height: 0.44rem;
      position: absolute;
      top: 0.24rem;
      background: #eec543;
      left: 0.24rem;
      text-align: center;
      line-height: 0.44rem;
      font-size: 0.28rem;
      color: rgba(0, 0, 0, 1);
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: center;
      border-radius: 0.04rem;
    }
    .status_end {
      background: #999;
    }
    .status_unstart {
      background: #ff7e1e;
    }

    .bottom_div {
      display: flex;
      background-color: #ffffff;
      width: 100%;
      padding-bottom: 16px;
      border-radius: 0rem 0rem 0.16rem 0.16rem;
      flex-direction: row;
      position: relative;
      .bottom_left {
        width: 100%;
        box-sizing: border-box;
        margin-top: 0.2rem;
        padding-left: 0.2rem;
        h2 {
          font-size: 0.32rem;
          font-weight: bold;
          color: #333;
          line-height: 0.44rem;
          .textOver(100%);
        }
        p {
          font-size: 0.28rem;
          color: #999;
          line-height: 0.4rem;
          padding-left: 0.4rem;
          background: url("../../../assets/images/time.png") left center
            no-repeat;
          background-size: 0.28rem 0.28rem;
          margin-top: 0.08rem;
        }
      }
      .bottom_right {
        position: absolute;
        bottom: 28px;
        right: 28px;
        white-space: nowrap;
        background: radial-gradient(circle at center , #d6bf9f 0%, #fff4e3 100%);
        border-radius: 23px;
        .price {
          height: 46px;
          font-size: 22px;
          padding-right: 20px;
          padding-left: 20px;
         
          line-height: 46px;
          color: #ffffff;
          
        }
      }
    }
  }
}
</style>
